import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { isKey } from '../../utils'
import { useTheme } from '../../theme'

import getStyles from './styles'

interface IChevronIconProps {
  color?: string
  direction?: 'up' | 'down' | 'left' | 'right'
  style?: Rule
}

export const ChevronIcon = function ChevronIcon({
  color = '#404e59',
  direction,
  style,
  ...additional
}: IChevronIconProps) {
  const directionKey = `direction-${direction}`
  const styles = getStyles(useTheme())
  return (
    <i
      {...css([
        styles.chevronIcon.base,
        isKey(styles.chevronIcon, directionKey) && styles.chevronIcon[directionKey],
        style,
      ])}
      {...additional}
    >
      <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <rect height="20" width="20" />
          <path
            d="M10.7097314,12.2061207 C10.3180332,12.5979252 9.68303395,12.5979943 9.29126652,12.2061207 L6.29543891,9.20948103 C5.90374063,8.81767658 5.90003967,8.18613802 6.2932533,7.7928178 L6.2932533,7.7928178 C6.6837445,7.40222075 7.32137399,7.40674015 7.7113054,7.79677726 L10.000499,10.0865914 L12.2896926,7.79677726 C12.6823699,7.40399346 13.314531,7.39949758 13.7077447,7.7928178 L13.7077447,7.7928178 C14.0982359,8.18341485 14.0973265,8.81760741 13.7055591,9.20948103 L10.7097314,12.2061207 Z"
            fill={color}
          />
        </g>
      </svg>
    </i>
  )
}

ChevronIcon.propTypes = {
  color: PropTypes.string,
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  style: PropTypes.object,
}
